'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _switchLocal = require('./switch.local.css');

var _switchLocal2 = _interopRequireDefault(_switchLocal);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

var Switch = function (_React$Component) {
  _inherits(Switch, _React$Component);

  function Switch(props) {
    _classCallCheck(this, Switch);

    var _this = _possibleConstructorReturn(this, (Switch.__proto__ || Object.getPrototypeOf(Switch)).call(this, props));

    _this._handleKeyPress = function (e) {
      if (e.key === 'Enter') {
        _this._toggleCheckbox();
      }
    };

    _this._toggleCheckbox = function () {
      _this.setState({
        checked: !_this.state.checked
      }, function () {
        _this.props.onClick(_this.state.checked ? _this.props.checked : _this.props.unchecked);
      });
    };

    _this.state = {
      checked: false,
      // we need each component to have a unique identifier, should there be multiple switches on a page
      uniqueId: Math.random().toString(36).substring(2, 15) + Math.random().toString(36).substring(2, 15)
    };
    return _this;
  }

  _createClass(Switch, [{
    key: 'render',
    value: function render() {
      return _react2.default.createElement('div', {
        className: _switchLocal2.default.toggle
      }, _react2.default.createElement('input', {
        id: this.state.uniqueId,
        type: 'checkbox',
        checked: this.state.checked,
        'aria-label': 'Toggle',
        onChange: this._toggleCheckbox
      }), _react2.default.createElement('label', {
        htmlFor: this.state.uniqueId,
        onKeyPress: this._handleKeyPress,
        tabIndex: 0 // eslint-disable-line

      }, _react2.default.createElement('div', {
        className: _switchLocal2.default.toggle__switch,
        'data-checked': this.props.checked,
        'data-unchecked': this.props.unchecked,
        style: {
          background: this.props.color,
          color: this.props.color,
          borderColor: this.props.color
        }
      })));
    }
  }]);

  return Switch;
}(_react2.default.Component);

Switch.displayName = 'Switch';
Switch.defaultProps = {
  checked: 'Default Checked',
  unchecked: 'Default Unchecked',
  color: '#000',
  onClick: function onClick() {}
};
Switch.propTypes = {
  checked: _propTypes2.default.string,
  // "Clicked" value
  unchecked: _propTypes2.default.string,
  // Default value on load
  color: _propTypes2.default.string,
  // Hex value to colour the "background" part of the switch and the switch's text
  onClick: _propTypes2.default.func // Function which will be passed either the checked or unchecked value

};
exports.default = Switch;